import { Component, OnInit, OnChanges, Input, Output } from '@angular/core';

@Component({
    selector: 'app-metal-level-box',
    templateUrl: './metal-level-box.component.html',
    styleUrls: ['./metal-level-box.component.scss']
})
export class MetalLevelBoxComponent implements OnInit, OnChanges {

    metalLevelClass = 'none';
    @Input() metalLevel = '';

    constructor() { }

    ngOnInit() {
    }

    ngOnChanges() {
        switch (this.metalLevel.toLowerCase()) {
            case 'gold':
                this.metalLevelClass = 'gold metal-box';
                break;
            case 'platinum':
                this.metalLevelClass = 'platinum metal-box';
                break;
            case 'silver':
                this.metalLevelClass = 'silver metal-box';
                break;
            case 'bronze':
                this.metalLevelClass = 'bronze metal-box';
                break;
            default:
                this.metalLevelClass = 'none';
                break;
        }
    }

}
